import React from 'react'
import { useNavigate } from 'react-router-dom'

const Topic0 = () => {

  const navigate = useNavigate()

  return (
    <div className="py-5 flex flex-col gap-5">
      <h2 className="text-xl sm:text-2xl xl:text-3xl font-bold">Refunderingspolitik</h2>
      <div className="tekst gap-10 flex flex-col">
        <div className="content flex flex-col gap-5">
          <div className="intro flex flex-col gap-2">
            <p className="font-medium">Når du køber et produkt på vores platform, har du mulighed for at få refunderet din ordre delvist, hvis et af følgende tilfælde er gældende for din handel:</p>
            <ul className="list-disc flex flex-col gap-2 pl-[20px]">
              <li>Din pakke er gået tabt i forsendelsen</li>
              <li>Bogens tilstand er anderledes end beskrevet</li>
            </ul>
            <p className="font-medium">Bemærk at forsendelsesomkostningerne kun refunderes, hvis din pakke er gået tabt i forsendelsen.</p>
          </div>
          <div className="flex flex-col gap-5">
            <div className="label flex flex-col gap-2">
              <h2 className="font-bold text-lg">Anmod om refundering</h2>
              <p className="">Vi giver dig besked, når din pakke enten er leveret eller gået tabt i forsendelsen. For at modtage en refundering, skal du rapportere dit problem <span className="font-semibold">senest 2 dage efter</span>.</p>
            </div>
            <div className="label flex flex-col gap-2">
              <h2 className="title font-semibold">Sådan gør du</h2>
              <p className="pl-[20px]">Under <span className="underline text-emerald-600 hover:text-emerald-700 transition-[] cursor-pointer" onClick={() => navigate('/dashboard/minebøger')}>Mine bøger</span> skal du vælge "<span className="font-semibold">Se detaljer</span>" ud for den vedrørende bog. Her finder du knappen "<span className="font-semibold">Anmod om refundering</span>" &mdash; tryk på den og vælg årsagen til refundering.</p>
            </div>
          </div>
        </div>
        <div className="important ring-1 shadow-md ring-emerald-500 p-5 flex gap-5 h-full">
          <div className="flex flex-col gap-2">
            <h2 className="font-semibold uppercase">Vigtigt</h2>
            <p>Hvis ikke du rapportere dit problem <span className="font-semibold">senest 2 dage efter</span> vores besked om, at din pakke er blevet leveret eller gået tabt i forsendelsen, frigives betalingen til sælgeren, og ordren vil ikke længere kunne  refunderes.</p>
          </div>
        </div>
        <div className="content flex flex-col gap-5">
          <div className="flex flex-col gap-5">
            <div className="label flex flex-col gap-2">
              <h2 className="font-bold text-lg">Hvordan refunderes betalingen?</h2>
              <p className="">Vi behandler din anmodning indenfor 24 timer, og hvis problemet bekræftes, refunderes pengene til dit anvendte betalingsmiddel. Der kan gå op til <span className="underline">10 dage</span> før du modtager pengene.</p>
            </div>
          </div>
        </div>
        <div className="questions">
          <p>Har du spørgsmål eller brug for yderligere hjælp til refundering af en ordre? <span className="text-emerald-600 hover:text-emerald-700 transition-[] cursor-pointer text-nowrap" onClick={() => navigate('/kontakt')}>Kontakt os</span>.</p>
        </div>
      </div>
    </div>
  )
}

export default Topic0